import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../helper/api";
import { toast } from "react-toastify";

export const updateClient = createAsyncThunk(
  "user/updateClient",
  async (payload) => {
   
    const response = await api.put(
      "admin/update-admin",
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      
    );

    return response.data;
  }
);

const updateClientSlice = createSlice({
  name: "user",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateClient.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateClient.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        toast.success(action.payload.message);
      })
      .addCase(updateClient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default updateClientSlice.reducer;
